var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"overflow-count"},[_c('v-icon',{attrs:{"small":"","color":"primary"}},[_vm._v(" mdi-star-outline ")]),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }